import { render, staticRenderFns } from "./interSchoolTime.vue?vue&type=template&id=25331223&scoped=true"
import script from "./interSchoolTime.vue?vue&type=script&lang=ts"
export * from "./interSchoolTime.vue?vue&type=script&lang=ts"
import style0 from "./interSchoolTime.vue?vue&type=style&index=0&id=25331223&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25331223",
  null
  
)

export default component.exports